import { routeParams } from '../models/route-to.model';

export function isRouteParams(value: unknown): value is routeParams {
    return typeof value === 'object' && value !== null && value !== undefined;
}
